class PropertyListController {

  constructor($scope, $state, propertyGroupService, messageService, permissionsService) {
    this.$scope = $scope;
    this.$state = $state;
    this.propertyGroupService = propertyGroupService;
    this.messageService = messageService;
    this.user = permissionsService.user;
  }

  $onInit() {
    this.updatePaging();
    this.$scope.$watch(
      function (scope) {
        return scope.current_page;
      },
      function (newVal, oldVal, scope) {
        if (newVal !== oldVal){
          if (scope.$ctrl.filtertext && scope.$ctrl.filtertype && scope.$ctrl.isFiltered){
            scope.$ctrl.propertyGroups = undefined;
            scope.$ctrl.propertyGroupService.search(scope.$ctrl.filtertype, scope.$ctrl.filtertext, newVal).then(response => {
              scope.$ctrl.propertyGroups = response;
              scope.$ctrl.loading = false;
            });
          }
          else{
            scope.$ctrl.propertyGroupService.findAll(newVal, scope.per_page)
              .then(list => scope.$ctrl.propertyGroups = list);
          }
        }
      }
    );
  }

  updatePaging(){
    this.$scope.per_page = this.propertyGroups.per_page;
    this.$scope.current_page = this.propertyGroups.current_page;
    this.$scope.total = this.propertyGroups.total;
  }

  onDelete(propertyGroup) {
    this.propertyGroupService.delete(propertyGroup.id)
      .then(() => {
        this.messageService.success(`The property group <strong>${propertyGroup.name}</strong> was successfully deleted.`);
        this.messageService.push();
      })
      .catch((error) => {
        this.messageService.failure(`The property group <strong>${propertyGroup.name}</strong> could not be successfully deleted: ${error.statusText}`);
        this.messageService.push();
      })
      .then(() => {
        let page = this.propertyGroups.current_page;
        this.propertyGroups = [];
        this.loading = true;
        return this.propertyGroupService.findAll(page).then(response => {
            this.propertyGroups = response;
            this.loading = false;
        });
      });
  }

  filter(){
    if (!this.loading && this.filtertext){
      this.startFilter();
      this.propertyGroupService.search(this.filtertype, this.filtertext).then(response => {
        this.isFiltered = true;
        this.endFilter(response);
      });
    }
  }

  clearfilter(){
    if (this.isFiltered) {
      this.startFilter();
      this.propertyGroupService.findAll(1, 20).then(response => {
        this.isFiltered = false;
        this.endFilter(response);
      });
    }
  }

  filtertypeChange() {
    switch(this.filtertype) {
      default:
        this.filtertext = '';
        break;
    }
  }

  startFilter(){
    this.propertyGroups = undefined;
    this.loading = true;
  }

  endFilter(response){
    this.propertyGroups = response;
    this.updatePaging();
    this.loading = false;
  }
}

PropertyListController.$inject = [ '$scope', '$state', 'propertyGroupService', 'messageService', 'permissionsService' ];

export default PropertyListController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/property/controllers/property.group.list.controller.js